/**
 * BehaviorFilters Component - Phase 2C-4
 *
 * Filter controls for behavior analytics.
 */

import { Card, CardContent, Select, Button } from '../common';
import { AdminPool } from '../../types';

interface BehaviorFiltersProps {
  pools: AdminPool[];
  selectedPoolId: string | null;
  onPoolChange: (poolId: string | null) => void;
  onRefresh: () => void;
  loading?: boolean;
}

export function BehaviorFilters({
  pools,
  selectedPoolId,
  onPoolChange,
  onRefresh,
  loading,
}: BehaviorFiltersProps): JSX.Element {
  const poolOptions = [
    { value: '', label: 'Select a pool...' },
    ...pools.map((p) => ({ value: p.pool_id, label: p.name || p.pool_id })),
  ];

  return (
    <Card>
      <CardContent className="p-4">
        <div className="flex items-end gap-4">
          <div className="w-64">
            <Select
              label="Pool"
              value={selectedPoolId || ''}
              onChange={(value) => onPoolChange(value || null)}
              options={poolOptions}
            />
          </div>
          <Button
            variant="secondary"
            onClick={onRefresh}
            disabled={loading || !selectedPoolId}
          >
            {loading ? 'Loading...' : 'Refresh'}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}